import {combineReducers} from 'redux';

import {fileStorageApi, metadaApi, omneticApi, promptBridgeApi, publicApi} from '@dms/api/base';
import {cachedApi, chatAgentApi} from '@dms/api/core';
import {branchSlice} from '@dms/api/features';
import i18n from '@dms/i18n';
import {teasReducers} from '@dms/teas';

import {
  createLanguageCheckTransform,
  createDuplicateKeysCheckTransform,
  persistRTKQReducer,
} from 'features/rtkq-persist';

const languageTransform = createLanguageCheckTransform(() => i18n.language);
const duplicateKeysTransform = createDuplicateKeysCheckTransform(() => i18n.language);

export const reducersDefinitions = {
  // RTK Query
  [publicApi.reducerPath]: publicApi.reducer,
  [omneticApi.reducerPath]: omneticApi.reducer,
  [metadaApi.reducerPath]: metadaApi.reducer,
  [fileStorageApi.reducerPath]: fileStorageApi.reducer,
  [cachedApi.reducerPath]: persistRTKQReducer(
    {
      key: cachedApi.reducerPath,
      transforms: [languageTransform, duplicateKeysTransform],
      // Drop persisted queries of endpoints that were renamed or removed since the data was stored
      knownEndpointNames: Object.keys(cachedApi.endpoints),
    },
    cachedApi.reducer
  ),
  [branchSlice.name]: branchSlice.reducer,
  [promptBridgeApi.reducerPath]: promptBridgeApi.reducer,
  [chatAgentApi.reducerPath]: chatAgentApi.reducer,
};

export const reducers = combineReducers({
  ...teasReducers,
  ...reducersDefinitions,
});

export type RootState = ReturnType<typeof reducers>;
